import { StyleSheet, Font } from '@react-pdf/renderer';
import Roboto from "Resources/Fonts/Roboto-Regular.ttf";
import RobotoBold from "Resources/Fonts/Roboto-Bold.ttf";

// Register font
Font.register({
  family: "Roboto",
  fonts: [
    { src: Roboto },
    { src: RobotoBold, fontWeight: 700 }
  ]
});

// #region STYLES
export const styles = StyleSheet.create({
  TicketPayzen_CodeBlock: {
    alignItems: "center",
    backgroundColor: "#EFF5FF",
    borderRadius: 8,
    marginTop: 4,
    paddingVertical: 6,
    paddingHorizontal: 10
  },
  TicketPayzen_CodeLabel: {
    color: "#2ca8dd",
    fontSize: 9,
    fontWeight: "bold",
    letterSpacing: 1,
    textTransform: "uppercase",
    marginBottom: 2
  },
  TicketPayzen_CodeValue: {
    color: "#101223",
    fontFamily: "Roboto",
    fontSize: 15,
    fontWeight: "bold"
  },
  TicketPayzen_Content: {
    backgroundColor: "#ffffff",
    borderRadius: 10,
    marginTop: 5,
    padding: 7
  },
  TicketPayzen_DetailAmount: {
    fontFamily: "Roboto",
    fontSize: 10,
    fontWeight: "normal"
  },
  TicketPayzen_DetailCard: {
    borderRadius: 8,
    border: "1px solid #2ca8dd",
    marginTop: 5,
    padding: 5,
    backgroundColor: "#F8FCFF"
  },
  TicketPayzen_DetailFooter: {
    borderTop: "1px solid #2ca8dd",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 4,
    paddingTop: 4
  },
  TicketPayzen_DetailHeading: {
    fontFamily: "Roboto",
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "center"
  },
  TicketPayzen_DetailInfo: {
    maxWidth: "72%"
  },
  TicketPayzen_DetailList: {
    marginTop: 3
  },
  TicketPayzen_DetailMeta: {
    color: "#8D97A8",
    fontSize: 9.5,
    fontWeight: "normal",
    marginTop: 0
  },
  TicketPayzen_DetailRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 2
  },
  TicketPayzen_DetailService: {
    fontFamily: "Roboto",
    fontSize: 10,
    fontWeight: "bold"
  },
  TicketPayzen_Header: {
    alignItems: "center",
    borderBottom: "1px solid #d7e2f3",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 4
  },
  TicketPayzen_HeaderTitle: {
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    marginLeft: "auto",
    color: "#101223"
  },
  TicketPayzen_Image: {
    height: 25,
    width: 100,
    marginBottom: 7
  },
  TicketPayzen_InfoLabel: {
    color: "#6f7d90",
    fontSize: 10
  },
  TicketPayzen_InfoRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 3
  },
  TicketPayzen_InfoText: {
    color: "#6f7d90",
    fontSize: 10,
    marginTop: 7,
    textAlign: "center"
  },
  TicketPayzen_MailInfoText: {
    color: "#6f7d90",
    fontSize: 10,
    marginTop: 8,
    textAlign: "center"
  },
  TicketPayzen_MailInfoSeparator: {
    borderTop: "1px solid #d7e2f3",
    marginTop: 12,
    paddingTop: 6,
    width: "100%"
  },
  TicketPayzen_InfoValue: {
    color: "#101223",
    fontSize: 10,
    flexShrink: 0,
    textAlign: "right"
  },
  TicketPayzen_InfoSpacer: {
    height: 8
  },
  TicketPayzen_Page: {
    backgroundColor: "#f2f5fb",
    padding: 7
  },
  TicketPayzen_PrimaryText: {
    fontFamily: "Roboto",
    fontSize: 10.5,
    fontWeight: "bold",
    textAlign: "center"
  },
  TicketPayzen_Section: {
    marginTop: 6
  },
  TicketPayzen_SectionTitle: {
    fontFamily: "Roboto",
    fontSize: 10,
    fontWeight: "bold",
    textTransform: "uppercase"
  },
  TicketPayzen_Text: {
    color: "#101223",
    fontFamily: "Roboto",
    fontSize: 11
  },
  TicketPayzen_TextEmphasis: {
    fontFamily: "Roboto",
    fontWeight: "bold"
  },
  TicketPayzen_TotalLabel: {
    textTransform: "uppercase"
  },
});
//#endregion
